import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const PdfViewerModal = ({ show, onHide, pdfUrl, docName }) => {
    const defaultLayout = defaultLayoutPlugin();
    return (
        <Modal show={show} onHide={onHide} size="xl" centered dialogClassName="modal-90w">
            <Modal.Header closeButton>
                <Modal.Title>Visualizando: {docName}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ height: '80vh' }}>
                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                    {show && pdfUrl ? (
                        <Viewer fileUrl={pdfUrl} plugins={[defaultLayout]} />
                    ) : null}
                </Worker>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Fechar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PdfViewerModal; 